import { render, staticRenderFns } from "./Principal.vue?vue&type=template&id=ba0731fe&scoped=true"
import script from "./Principal.vue?vue&type=script&lang=js"
export * from "./Principal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0731fe",
  null
  
)

export default component.exports